<template>
  <div class="tree-root">
    <tree-item :item="item" v-for="(item, index) in treeList" :key="index"></tree-item>
  </div>
</template>

<script>
import TreeItem from './treeItem'
export default {
  name: 'treeRoot',
  components: {TreeItem},
  props: {
    treeList: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/agent/components/treeRoot.vue